require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./radio"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./radio"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./radio")) : factory(root["./utils"], root["./radio"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__83__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[48],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(460);


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _RadioGroup = _interopRequireDefault(__webpack_require__(461));

exports.default = _RadioGroup.default;
exports.RadioGroup = _RadioGroup.default;

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _radio = __webpack_require__(83);

var _baUiCarbon = __webpack_require__(9);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes
} = _utils.propsUtils;

class RadioGroup extends _react.Component {
  render() {
    const {
      // remove - remapped

      /* eslint-disable react/prop-types */
      labelPosition,
      orientation,
      valueSelected,

      /* eslint-enable react/prop-types */
      children,
      // remove - deprecated
      align,
      checked,
      direction,
      options,
      readOnly,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      selectedId,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // pass all other props to RadioButtonGroup
      ...otherRadioButtonGroupProps
    } = this.props;
    const mappedLabelPosition = labelPosition != null ? labelPosition : align === 'right' ? 'left' : undefined;
    const mappedOrientation = orientation != null ? orientation : direction;
    const mappedValueSelected = valueSelected != null ? valueSelected : checked;
    const mappedChildren = children != null ? children : options.map(props => (0, _radio.renderCarbonRadioButton)(props));
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.RadioButtonGroup, (0, _extends2.default)({}, otherRadioButtonGroupProps, {
      labelPosition: mappedLabelPosition,
      orientation: mappedOrientation,
      valueSelected: mappedValueSelected
    }), mappedChildren);
  }

}

exports.default = RadioGroup;
(0, _defineProperty2.default)(RadioGroup, "propTypes", {
  /** Provide a collection of <RadioButton> components to render in the group */
  children: _propTypes.default.array.isRequired,

  /** deprecated - use labelPosition */
  align: BaPropTypes.deprecated('deprecated - use labelPosition'),

  /** deprecated - use valueSelected */
  checked: BaPropTypes.deprecated('deprecated - use valueSelected'),

  /** deprecated - use orientation */
  direction: BaPropTypes.deprecated('deprecated - use orientation'),

  /** deprecated - pass RadioButton options as children of RadioButtonGroup */
  options: BaPropTypes.deprecated('deprecated - pass RadioButton options as children of RadioButtonGroup'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - no Carbon option */
  selectedId: BaPropTypes.deprecated('deprecated - no Carbon option')
});

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__83__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[459,0]]]);
});